"use strict";

var _objectWithoutProperties = require("/root/website/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _slicedToArray = require("/root/website/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkGroup = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _useFooter = require("../../useFooter");

var _Link = require("../Link");

var _styles = require("./styles");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  'data-testid': _propTypes.string,
  id: _propTypes.string,
  links: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    href: _propTypes.string,
    label: _propTypes.string,
    rel: (0, _propTypes.oneOf)(['noopener', 'noreferrer']),
    target: (0, _propTypes.oneOf)(['_self', '_blank', '_parent', '_top'])
  })),
  title: _propTypes.string
} : {};
var defaultProps = {
  id: 'LinkGroup',
  'data-testid': 'LinkGroup'
};

var LinkGroup = function LinkGroup(_ref) {
  var dataTestId = _ref['data-testid'],
      id = _ref.id,
      links = _ref.links,
      title = _ref.title;

  var _ref2 = (0, _useFooter.useFooter)(),
      device = _ref2.device;

  var _ref3 = (0, _react.useState)(false),
      _ref4 = _slicedToArray(_ref3, 2),
      expanded = _ref4[0],
      setExpanded = _ref4[1];

  var isMobile = device === 'mobile';

  var handleAccordionClick = function handleAccordionClick() {
    return setExpanded(!expanded);
  };

  var accordionProps = {
    mobile: {
      'aria-controls': "list_".concat(id),
      'aria-expanded': expanded,
      as: 'button',
      id: "button_".concat(id),
      onClick: handleAccordionClick
    },
    desktop: {
      as: 'div'
    }
  };
  var listProps = {
    mobile: {
      'aria-hidden': !expanded,
      'aria-labelledby': "button_".concat(id),
      id: "list_".concat(id),
      role: 'region'
    },
    desktop: null
  };
  return (0, _core.jsx)(_styles.Wrapper, {
    "data-testid": dataTestId
  }, title && (0, _core.jsx)(_styles.AccordionButton, accordionProps[device], (0, _core.jsx)(_styles.Title, null, title), isMobile && (0, _core.jsx)(_styles.ArrowDown, {
    "data-testid": "".concat(dataTestId, "-icon"),
    "aria-expanded": expanded,
    "aria-hidden": true
  })), (links == null ? void 0 : links.map) && (0, _core.jsx)(_styles.List, (0, _extends2.default)({
    "data-testid": "".concat(dataTestId, "-list")
  }, listProps[device]), links.map(function (_ref5, index) {
    var label = _ref5.label,
        otherLinkProps = _objectWithoutProperties(_ref5, ["label"]);

    return (0, _core.jsx)(_styles.ListItem, {
      key: "ListItem-".concat(index)
    }, (0, _core.jsx)(_Link.Link, (0, _extends2.default)({
      gaAction: title,
      gaCategory: "menu"
    }, otherLinkProps), label));
  })));
};

exports.LinkGroup = LinkGroup;
process.env.NODE_ENV !== "production" ? LinkGroup.propTypes = propTypes : void 0;
LinkGroup.defaultProps = defaultProps;
LinkGroup.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "LinkGroup",
  "props": {
    "id": {
      "defaultValue": {
        "value": "'LinkGroup'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "data-testid": {
      "defaultValue": {
        "value": "'LinkGroup'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "links": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "href": {
              "name": "string",
              "required": false
            },
            "label": {
              "name": "string",
              "required": false
            },
            "rel": {
              "name": "enum",
              "value": [{
                "value": "'noopener'",
                "computed": false
              }, {
                "value": "'noreferrer'",
                "computed": false
              }],
              "required": false
            },
            "target": {
              "name": "enum",
              "value": [{
                "value": "'_self'",
                "computed": false
              }, {
                "value": "'_blank'",
                "computed": false
              }, {
                "value": "'_parent'",
                "computed": false
              }, {
                "value": "'_top'",
                "computed": false
              }],
              "required": false
            }
          }
        }
      },
      "required": false,
      "description": ""
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};